import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD, formatDateTime } from '../../../shared/format.js';
import { ReceiptBrand } from '../../../shared/ReceiptBrand.jsx';
import { printReceipt } from '../../../shared/printReceipt.js';

export function InvoicePreviewModal({ invoice, onClose, onContinue, onNew, onRequestCancel }) {
  if (!invoice) return null;

  function print() {
    printReceipt();
  }

  const items = invoice.items || [];
  const child = invoice.childId || invoice.child || null;
  const cashier = invoice.cashierId || invoice.cashier || null;
  const method = invoice.paymentMethod;
  const methodLabel =
    method === 'cash' ? 'نقدي' :
    method === 'card_balance' ? 'رصيد الكارت' :
    method === 'on_session' ? 'تعليق على الكارت' :
    method === 'external' ? 'خارجي' : method;

  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center"
      style={{ background: 'rgba(0,0,0,.5)' }}
    >
      <div className="card w-[420px] max-w-[92vw] p-0" onClick={(e) => e.stopPropagation()}>
        <div className="card-h">
          <div className="flex-1">
            <h3 className="text-[15px] font-bold">تم البيع بنجاح</h3>
            <div className="text-xs text-ink-3">فاتورة #{invoice.number}</div>
          </div>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>

        <div className="card-b">
          <div
            className="receipt-print-area mx-auto bg-white text-ink p-4"
            style={{
              width: 280,
              fontFamily: '"Tajawal", monospace',
              fontSize: 12,
              boxShadow: '0 4px 14px rgba(0,0,0,.08)',
              borderRadius: 8
            }}
          >
            <ReceiptBrand
              subtitle={invoice.posType === 'cafeteria' ? 'إيصال كافتيريا' : 'إيصال محل ألعاب'}
            />
            <hr className="border-dashed my-1" />
            <div className="flex justify-between"><span>الفاتورة</span><span dir="ltr">{invoice.number}</span></div>
            <div className="flex justify-between"><span>التاريخ</span><span>{formatDateTime(invoice.createdAt)}</span></div>
            {cashier ? <div className="flex justify-between"><span>الكاشير</span><span>{cashier.fullName || cashier.username || ''}</span></div> : null}
            {child ? <div className="flex justify-between"><span>الطفل</span><span>{child.name || ''}</span></div> : null}
            {invoice.cardUid ? <div className="flex justify-between"><span>الكارت</span><span dir="ltr" style={{ fontFamily: 'monospace' }}>{invoice.cardUid}</span></div> : null}
            <hr className="border-dashed my-1" />
            <div className="font-semibold mb-1">الأصناف:</div>
            {items.map((it, i) => (
              <div key={i} className="flex justify-between">
                <span className="truncate" style={{ maxWidth: 150 }}>{it.qty}× {it.productName || it.name}</span>
                <span>{formatIQD((it.qty * (it.unitPrice || 0)) - (it.discount || 0))}</span>
              </div>
            ))}
            <hr className="border-dashed my-1" />
            <div className="flex justify-between"><span>المجموع الفرعي</span><span>{formatIQD(invoice.subtotal || 0)}</span></div>
            {invoice.discountTotal ? (
              <div className="flex justify-between"><span>خصم</span><span>-{formatIQD(invoice.discountTotal)}</span></div>
            ) : null}
            <div className="flex justify-between font-extrabold text-[14px]">
              <span>الإجمالي</span>
              <span style={{ color: '#C2570D' }}>{formatIQD(invoice.grandTotal || 0)}</span>
            </div>
            <div className="flex justify-between"><span>طريقة الدفع</span><span>{methodLabel}</span></div>
            {method === 'cash' && invoice.paidAmount ? (
              <div className="flex justify-between"><span>المستلم</span><span>{formatIQD(invoice.paidAmount)}</span></div>
            ) : null}
            <div className="text-center text-[10px] mt-2">شكراً لزيارتكم</div>
          </div>
        </div>

        <div className="card-h border-t border-b-0 flex flex-wrap justify-end gap-2">
          {/* إلغاء الفاتورة من هنا مباشرة: الخطأ يُكتشف غالباً لحظة طباعة
              الوصل، وإجبار الكاشير على البحث عنها لاحقاً يؤخّر الإرجاع. */}
          {onRequestCancel && invoice.paymentStatus !== 'cancelled' ? (
            <button
              type="button"
              className="btn text-red me-auto"
              onClick={() => onRequestCancel(invoice)}
            >
              <Icon name="trash" size={14} /> إلغاء الفاتورة
            </button>
          ) : null}
          {onContinue ? (
            <button type="button" className="btn" onClick={onContinue}>
              متابعة على نفس الطفل
            </button>
          ) : null}
          {onNew ? (
            <button type="button" className="btn" onClick={onNew}>
              بيع جديد
            </button>
          ) : null}
          <button type="button" className="btn btn-primary" onClick={print}>
            <Icon name="print" size={14} /> طباعة
          </button>
        </div>
      </div>
    </div>
  );
}
